export const validateFileSize = (size: number) => {
  const maxSize = 2 * 1024 * 1024; // 2MB
  return size <= maxSize;
};
